import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/sections/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroForm"] */ "/app/src/components/sections/HeroForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/app/src/components/sections/LocaleSwitcher.tsx");
